const runtimeServer = (window as Window & { SENTIO_CONFIG?: { server?: string } }).SENTIO_CONFIG?.server;
export const HOST = (runtimeServer || process.env.REACT_APP_SERVER)?.replace(/\/?$/, "/");

// export const HOST =
//     process.env.NODE_ENV === "development"
//         ? process.env.REACT_APP_SERVER
//         : window.location.href;

export const WS_HOST = () => {
	if (HOST!.substring(0, 5) === "https") {
		return HOST!.replace("https://", "wss://");
	}
	return HOST!.replace("http://", "ws://");
};

export const DEFAULT_AUTOLOGOUT_MINUTES = 15; // 15 minutes default for auto-logout after no activity
export const DEFAULT_AUTOLOGOUT_SECONDS = DEFAULT_AUTOLOGOUT_MINUTES * 60;
export const CONNECTIVITY_TIMEOUT = 30 * 1000;

export const MAP_TILE_URL =
	"https://tile.jawg.io/1a3bb38c-fc14-4a39-91b2-9bf3738d0850/{z}/{x}/{y}{r}.png?access-token=cl4DjZDEwMUCIKkxRgdeFZb4MaERLc8degcELVw9BcapTstY1jN1rlLIrHJHW2w5";
export const MAP_ATTRIBUTION =
	'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';

export const isPharlap = localStorage.getItem("SYSTEM_TYPE") === "PHARLAP";
export const isSentio = localStorage.getItem("SYSTEM_TYPE") === "SENTIO";
